import React, { useState, useEffect } from "react";
import { Grid } from "@mui/material";
import ComingSoon from "../../subComponents/ComingSoon";
import Menu from "../../subComponents/Menu";
import { Pupils, UploadResult } from ".";
import { useDispatch } from "react-redux";
import { getStafffLoginCred, pupilsThunk } from "../../redux/staffSlice";

const Staff = () => {
  const [section, setSection] = useState("staff");

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getStafffLoginCred());
    setTimeout(() => {
      dispatch(pupilsThunk());
    }, 1000);
  }, []);

  return (
    <Grid container style={{ height: "100vh" }}>
      <Grid item xs={3}>
        <Menu
          setSection={setSection}
          menuSections={[
            {
              subHeader: "Administrative",
              subItem: ["Pupils", "Attendance", "Upload Results"],
            },
            { subHeader: "Utilities", subItem: ["Upcoming Events"] },
          ]}
        />
      </Grid>
      <Grid item xs={9}>
        {section === "" && <ComingSoon />}
        {section === "pupils" && <Pupils />}
        {section === "upload results" && <UploadResult />}
      </Grid>
    </Grid>
  );
};

export default Staff;
